<template>
  <div class="root">
    <RowOptions v-if="selectedRow" v-model="selectedRow" @close="deselectRow" />
    <MainMenu v-else />
  </div>
</template>

<script setup>
import { Context } from "../../constants";
import { useLayoutBuilderStore } from "../../store/layout-builder";
import MainMenu from "./MainMenu/MainMenu.ce.vue";
import RowOptions from "./RowOptions/RowOptions.ce.vue";

const { selectedRow, deselectRow } = useLayoutBuilderStore({ context: Context.PARENT });
</script>

<style scoped lang="scss">
.root {
  --sp-comp-list-item-active-display-divider: none !important;
  --sp-comp-list-item-active-display-next-divider: none !important;
  --sp-comp-list-item-active-hover-display-divider: none !important;
}
</style>
